export default "__VITE_ASSET__CialKVne__"